import React, { useState, useEffect, useRef } from 'react';
import '../login/login.css';
import ArrowBack from '../../assets/icons/arrow-back.svg';
import Eye from '../../assets/icons/eye.svg';
import HideEye from '../../assets/icons/close-eye.svg';
import BlueLogo from '../../assets/images/blue-logo.svg';
import { Form } from 'react-bootstrap';
import 'primeicons/primeicons.css';
import { IsMobileExsits, sendOtp, RegisterByOtp, loginByOtp, sendRegisterOtp } from "../../utils/api";
import Loader from '../loader/loader';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { useDispatch } from 'react-redux';
import useStickToTopModal from '../../hooks/useStickToTopModal';
import { isAndroid } from 'react-device-detect';
import NotificationHandler from '../custom/notification-handler';
import { ToastContainer, toast } from 'react-toastify';
import useToastNotification from '../../hooks/useToastNotification';
import EditIcon from '../../assets/icons/panel/edit.svg';

function FastLogin(props) {
    const dispatch = useDispatch();
    const [mobileVisible, setMobileVisible] = useState(true);
    const [otpLoginVisible, setOtpLoginVisible] = useState(false);
    const [otpRegisterVisible, setOtpRegisterVisible] = useState(false);
    const [mobileSection, setMobileSection] = useState(true);
    const [OTPSection, setOTPSection] = useState(false);
    const [PasswordSection, setPasswordSection] = useState(false);
    const [typePassword, setTypePassword] = useState('password');
    const [time, setTime] = useState(240);
    const [isActive, setIsActive] = useState(false);
    const [resendBtn, setResendBtn] = useState(true);
    const [resendCode, setResendCode] = useState(false);
    const [checkMobileLoader, setCheckMobileLoader] = useState(false);
    const [otpLoader, setOtpLoader] = useState(false);
    const [passwordLoader, setPasswordLoader] = useState(false);
    const [validated, setValidated] = useState(false);
    const [validatedOtp, setValidatedOtp] = useState(false);
    const [password, setPassword] = useState('');
    const [otpPassword, setOtpPassword] = useState('');
    const [nationalCode, setNationalCode] = useState('');
    const [mobile, setMobile] = useState('');

    const { showError, showSuccess } = useToastNotification();

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.removeProperty("overflow");
        };
    }, []);

    const onCloseModal = () => {
        !!props.onClose && props.onClose();
    };

    const checkMobile = async () => {
        setCheckMobileLoader(true);
        if (mobile.length === 11) {
            try {
                let pay = { mobile: mobile };
                let res = await IsMobileExsits(pay);
                if (res.statusText === "OK") {
                    if (res.data.isSuccess) {
                        showSuccess({ text: res.data.message });
                        setCheckMobileLoader(false);
                        setOtpLoginVisible(true);
                        setMobileVisible(false);
                        sendOtpfunction();
                    } else {
                        setCheckMobileLoader(false);
                        showError({ text: res.data.message });
                        setOtpRegisterVisible(true);
                        sendOtpRegisterfunction();
                        setMobileVisible(false);
                    }
                }
            } catch (error) {
                setCheckMobileLoader(false);
                showError({ text: 'خطا در ارتباط با سرور' });
            }
        } else {
            showError({ text: 'لطفا شماره موبایل را به صورت صحیح وارد کنید.' });
            setCheckMobileLoader(false);
        }
    };

    const sendOtpfunction = async () => {
        try {
            setTime(240);
            setIsActive(true);
            setResendBtn(true);
            let res = await sendOtp({ mobile });
            if (!res.data.isSuccess) {
                showError({ text: res.data.message });
            }
        } catch (error) {
            showError({ text: error.response.data.error });
        }
    };

    const sendOtpRegisterfunction = async () => {
        try {
            setTime(240);
            setIsActive(true);
            setResendBtn(true);
            let res = await sendRegisterOtp({ mobile });
            if (!res.data.isSuccess) {
                showError({ text: res.data.message });
            }
        } catch (error) {
            showError({ text: error.response.data.error });
        }
    };

    const funcLoginByOtp = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            setTime(240);
            setIsActive(true);
            setOtpLoader(true);
            setResendBtn(true);
            if (otpPassword.length === 6) {
                try {
                    let pay = { otp: otpPassword, mobile };
                    let res = await loginByOtp(pay);
                    if (res.statusText === "OK") {
                        if (res.data.isSuccess) {
                            setOtpLoader(false);
                            localStorage.setItem('token', JSON.stringify(res.data.data.token));
                            localStorage.setItem('userData', JSON.stringify(res.data.data));
                            dispatch({ type: 'SET_CUSTOMER_DATA', payload: res.data.data });
                            setOtpLoginVisible(false);
                            showSuccess({ text: "ورود موفقیت آمیز" });
                            if (props.successAction) {
                                props.successAction();
                            }
                        } else {
                            setOtpLoader(false);
                            showError({ text: res.data.message });
                        }
                    }
                } catch (error) {
                    setOtpLoader(false);
                    showError({ text: 'خطا در ارتباط با سرور' });
                }
            } else {
                showError({ text: `لطفا کد ارسال شده را صحیح وارد کنید.` });
                setOtpLoader(false);
            }
        }
        setValidatedOtp(true);
    };

    const funcRegisterByOtp = async (e) => {
        e.preventDefault();
        setOtpLoader(true);
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            try {
                let pay = { otp: otpPassword, mobile, nationalCode };
                let res = await RegisterByOtp(pay);
                if (res.statusText === "OK") {
                    if (res.data.isSuccess) {
                        setOtpLoader(false);
                        localStorage.setItem('token', JSON.stringify(res.data.data.token));
                        localStorage.setItem('userData', JSON.stringify(res.data.data));
                        dispatch({ type: 'SET_CUSTOMER_DATA', payload: res.data.data });
                        setOtpRegisterVisible(false);
                        showSuccess({ text: "ورود موفقیت آمیز" });
                        if (props.successAction) {
                            props.successAction();
                        }
                    } else {
                        setOtpLoader(false);
                        showError({ text: res.data.message });
                    }
                }
            } catch (error) {
                setOtpLoader(false);
                showError({ text: 'خطا در ارتباط با سرور' });
            }
        }
        setValidatedOtp(true);
    };

    const showPassword = () => {
        setTypePassword('text');
    };

    const hidePassword = () => {
        setTypePassword('password');
    };

    useEffect(() => {
        let timerId;
        if (isActive && time > 0) {
            timerId = setInterval(() => {
                setTime(prevTime => prevTime - 1);
            }, 1000);
        } else if (time === 0) {
            onTimerFinish();
        }
        return () => clearInterval(timerId);
    }, [isActive, time]);

    const onTimerFinish = () => {
        setResendCode(true);
        setResendBtn(false);
    };

    const formatTime = (time) => {
        const minutes = String(Math.floor(time / 60)).padStart(2, '0');
        const seconds = String(time % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    const { modalClassName, onKeyboardClose, onKeyboardOpen, stickToTop } = useStickToTopModal();

    useEffect(() => {
        let timerId;
        
        // بررسی پشتیبانی مرورگر از WebOTP API
        if ('OTPCredential' in window) {
            const ac = new AbortController();
    
            // تابع برای دریافت کد OTP
            const getOtp = () => {
                navigator.credentials
                    .get({
                        otp: { transport: ['sms'] },
                        signal: ac.signal,
                    })
                    .then((otp) => {
                        if (otp?.code) {
                            setOtpPassword(otp.code); // قرار دادن کد در فیلد OTP
                            ac.abort(); // متوقف کردن درخواست
                            clearInterval(timerId); // متوقف کردن تایمر
                        }
                    })
                    .catch((err) => {
                        console.error(err); // خطا را در کنسول لاگ کنید (اختیاری)
                    });
            };
    
            // شروع بررسی هر 5 ثانیه یکبار
            timerId = setInterval(getOtp, 5000);
    
            // تمیز کردن درخواست و تایمر در هنگام unmount
            return () => {
                ac.abort();
                clearInterval(timerId);
            };
        }
    
        // فقط زمانی که صفحه OTP باز است اجرا شود
    }, [otpLoginVisible, otpRegisterVisible]);
    

    return (
        <>
            <Dialog className={`animation ${stickToTop ? modalClassName : ''}`} header="ورود" visible={mobileVisible} style={{ width: '40vw' }} onHide={() => { if (!mobileVisible) return; setMobileVisible(false); onCloseModal() }}>
                <div className='login-card w-100'>
                    <div className='item mx-0' >
                        <h6 className='text-xl text-end font-medium color-primary2 mt-3'>برای ورود لطفا شماره موبایل خود را وارد کنید.</h6>
                        <Form className='mt-3'>
                            <Form.Group controlId="text" >
                                <Form.Label style={{ fontWeight: '600' }}>شماره موبایل</Form.Label>
                                <Form.Control type="number" inputMode="numeric" value={mobile} onChange={(e) => {
                                    if (e.target.value.length <= 11) {
                                        setMobile(e.target.value);
                                    }
                                }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            checkMobile(e);
                                        }
                                    }} onBlur={onKeyboardClose} onFocus={onKeyboardOpen} />
                            </Form.Group>
                            <h5 className='mt-5 color-primary text-base'>ورود شما به معنای <a>پذیرش شرایط کادونا و قوانین حریم خصوصی</a> است.</h5>
                            <button className='btn btn-primary w-100 mt-1 text-center' disabled={checkMobileLoader} onClick={checkMobile} type='button' style={{ width: 'auto' }}>ورود {checkMobileLoader && <Loader />}</button>
                        </Form>
                    </div>
                </div>
            </Dialog>

            <Dialog header="ورود" className={`${stickToTop ? modalClassName : ''}`} visible={otpLoginVisible} style={{ width: '45vw' }} onHide={() => { if (!otpLoginVisible) return; setOtpLoginVisible(false); onCloseModal() }}>
                <div className='login-card w-100'>
                    <div className='item mx-0'>
                        <h6 className='text-xl font-medium color-primary2 mt-3'>کد تایید ارسالی  برای شماره <br className='mobile' /><button type='button' style={{ marginBottom: '8px' }} className='btn text-center color-primary' onClick={() => {
                            setCheckMobileLoader(false);
                            setOtpLoginVisible(false);
                            setMobileVisible(true);
                        }}><img src={EditIcon} /></button>{mobile} را وارد کنید.</h6>
                        <Form className='mt-5' noValidate validated={validatedOtp} onSubmit={(e) => funcLoginByOtp(e)}>
                            <Form.Group controlId="postalCode">
                                <Form.Label style={{ fontWeight: '600' }}>کد تایید</Form.Label>
                                <Form.Control className='number' id="otpLogin"
                                    name="otpLogin" type="number" inputMode="numeric" autoComplete="one-time-code" required value={otpPassword} onChange={(e) => {
                                        if (e.target.value.length <= 6) {
                                            setOtpPassword(e.target.value);
                                        }
                                    }} onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            funcLoginByOtp(e);
                                        }
                                    }} onBlur={onKeyboardClose} onFocus={onKeyboardOpen} />
                            </Form.Group>
                            <button type='button' disabled={resendBtn} className='btn w-100 text-center mt-2' onClick={sendOtpfunction}> {!resendBtn ? 'ارسال مجدد' : formatTime(time)}</button>
                            <button className='btn btn-primary mt-4 w-100 mt-1 text-center' type='submit' disabled={otpLoader} style={{ width: 'auto' }}>تایید {otpLoader && <Loader />}</button>
                        </Form>
                    </div>
                </div>
            </Dialog>

            <Dialog header="ثبت نام" className={`${stickToTop ? modalClassName : ''}`} visible={otpRegisterVisible} style={{ width: '40vw' }} onHide={() => { if (!otpRegisterVisible) return; setOtpRegisterVisible(false); onCloseModal() }}>
                <div className='login-card w-100'>
                    <div className='item mx-0'>
                        <h6 className='text-xl font-medium color-primary2 mt-3'>حساب کاربری با شماره موبایل <br className='mobile' /><button type='button' style={{ marginBottom: '8px' }} className='btn text-center color-primary' onClick={() => {
                            setCheckMobileLoader(false);
                            setOtpLoginVisible(false);
                            setMobileVisible(true);
                        }}><img src={EditIcon} /></button> {mobile} وجود ندارد. برای ساخت حساب جدید، کد تایید برای این شماره ارسال گردید.</h6>
                        <Form className='mt-5' noValidate validated={validatedOtp} onSubmit={(e) => funcRegisterByOtp(e)}>
                            <Form.Group >
                                <Form.Label style={{ fontWeight: '600' }}>کد ملی</Form.Label>
                                <Form.Control onBlur={onKeyboardClose} onFocus={onKeyboardOpen} type='number' inputMode="numeric" required value={nationalCode} onChange={(e) => setNationalCode(e.target.value)} />
                                <Form.Control.Feedback type="invalid">
                                    کدملی را وارد کنید
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group controlId="postalCode" >
                                <Form.Label style={{ fontWeight: '600' }}>کد تایید</Form.Label>
                                <Form.Control className='number' id="otpRegister"
                                    name="otpRegister" type="number" autoComplete="one-time-code" inputMode="numeric" required value={otpPassword} onChange={(e) => {
                                        if (e.target.value.length <= 6) {
                                            setOtpPassword(e.target.value);
                                        }
                                    }} onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            funcLoginByOtp(e);
                                        }
                                    }} onBlur={onKeyboardClose} onFocus={onKeyboardOpen} />
                            </Form.Group>
                            <button type='button' disabled={resendBtn} className='btn w-100 text-center mt-2' onClick={(e) => sendOtpRegisterfunction(mobile)}> {!resendBtn ? 'ارسال مجدد' : formatTime(time)}</button>
                            <button className='btn btn-primary mt-4 w-100 mt-1 text-center' type='submit' disabled={otpLoader} style={{ width: 'auto' }}>تایید {otpLoader && <Loader />}</button>
                        </Form>
                    </div>
                </div>
            </Dialog>
        </>
    );
}

export default FastLogin;